import type Validator from '../../models/Validator';
import { EMAIL_REGEX } from '../../constants/stringConstants';

const EmailValidator: Validator = class {
  static isValid(value) {
    return EMAIL_REGEX.test(value);
  }

  static getError() {
    return 'Enter a valid email address';
  }
};

export default EmailValidator;
